import React, { Fragment, useMemo, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Link, useHistory } from "react-router-dom";
import Popup from "reactjs-popup";
import _ from "lodash";
import {
  AppBar,
  Toolbar,
  Button,
  Hidden,
  IconButton,
  withStyles,
  withWidth,
  isWidthUp,
  Box,
  Badge,
  Tooltip,
  Fade,
  Typography,
  Divider,
  Paper,
} from "@material-ui/core";
import { Menu } from "@material-ui/icons";
import NavigationDrawer from "shared/components/NavigationDrawer";
import { logout } from "utils";
import { ImgNav } from "utils/imgSource";
import { Navigation, UserNavigation, LoginNavigation } from "utils/constant";
import { storageKey, get } from "utils/storage";
import { useRequest } from "hooks";
import { tokenInvalid, messageCount } from "services/api";

const menuItems = _.values(Navigation);
// 登录
const userLogoutMenuItems = _.values(LoginNavigation);

const hasNotShadow = [
  UserNavigation?.notifies?.value,
  UserNavigation?.back?.list[0].value,
  UserNavigation?.back?.list[1].value,
  UserNavigation?.back?.list[2].value,
];

export const MPopup = (props) => {
  const { element, selectedTab, ...rest } = props;
  return (
    <Popup
      lockScroll
      on={["hover", "click"]}
      // on="click"
      position="bottom center"
      arrow={false}
      closeOnDocumentClick={false}
      {...rest}
    >
      <MenuItemList menu={element?.list} selectedTab={selectedTab} />
    </Popup>
  );
};

const styles = (theme) => ({
  appBar: {
    boxShadow: theme.palette.shadows,
    backgroundColor: theme.palette.common.white,
  },
  shadow: {
    boxShadow: "none",
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
  },
  menuButtonText: {
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.common.transparent,
    },
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.h6.fontWeight,
  },
  noDecoration: {
    textDecoration: "none !important",
    color: theme.palette.common.black,
  },
  img: {
    maxHeight: 60,
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      maxHeight: 50,
    },
    [theme.breakpoints.down("sm")]: {
      maxHeight: 40,
    },
  },
  iconBtn: {
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.common.transparent,
    },
  },
  paper: {
    boxShadow: theme.palette.shadows,
    backgroundColor: theme.palette.common.white,
  },
  menuItem: {
    "&:hover": {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.common.transparent,
      cursor: "pointer",
    },
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    textAlign: "center",
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
  },
  textSecondary: {
    color: `${theme.palette.secondary.main} !important`,
  },
  textBlack: {
    color: `${theme.palette.common.black} !important`,
  },
});

const MenuItemList = withStyles(styles, { withTheme: true })(
  (props) => {
    const { classes, menu, selectedTab } = props;

    const isSelected = useCallback((val) => {
      const is = selectedTab.indexOf(val) !== -1;
      return is || val === selectedTab;
    }, [selectedTab]);

    return (
      <Paper className={classes.paper}>
        {_.isArray(menu) && _.map(menu, m => {
          const isActive = isSelected(m.value);
          const defaultView = (
            <Typography
              variant="body1"
              className={clsx(classes.menuItem, {
                [classes.textSecondary]: isActive
              })}
            >
              {m.name}
            </Typography>
          );
          let mview = defaultView;
          if (_.isArray(m.list) && m.list.length) {
            mview = (
              <MPopup
                element={m}
                arrow
                position="right top"
                trigger={defaultView}
                selectedTab={selectedTab}
              />
            );
          }
          if (m.link) {
            mview = (
              <Link
                to={m.link}
                className={classes.noDecoration}
              >
                {defaultView}
              </Link>
            );
          }
          if (m.onClick && m.click) {
            mview = (
              <Button
                fullWidth
                onClick={m.onClick}
                classes={{
                  text: clsx(classes.menuItem, {
                    [classes.textSecondary]: isActive
                  })
                }}
              >
                {m.name}
              </Button>
            );
          }
          return (
            <Fragment key={m.value}>
              {mview}
              <Divider />
            </Fragment>
          );
        })}
      </Paper>
    );
  });
MenuItemList.prototypes = {
  classes: PropTypes.object,
  menu: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.element,
    popup: PropTypes.bool,
    list: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      link: PropTypes.string,
      onClick: PropTypes.func,
    }))
  })).isRequired,
  selectedTab: PropTypes.string.isRequired,
};

function NavBar(props) {
  const { classes, width, handleMobileDrawerOpen, selectedTab } = props;
  const { mobileDrawerOpen, handleMobileDrawerClose } = props;
  const history = useHistory();
  const [menu, setMenu] = useState([]);
  const [iconMenu, setIconMenu] = useState(userLogoutMenuItems)
  const [isUserDrawer, setIsUserDrawer] = useState(false);
  const [loginMenu, setLoginMenu] = useState([]);
  // 消息数
  const [runMsg, msgCount] = useRequest({ ...messageCount });
  // token检验
  const [run, result] = useRequest({ 
    ...tokenInvalid,
    onSuccess: ({ data }) => {
      if (!data) {
        logout("登录信息过期，请重新登录！", "warning");
        reloadAndGoHome();
      } else {
        runMsg();
      }
    }
  });
  
  const userInfo = get(storageKey.userInfo);
  
  const isSelected = useCallback((val) => {
    const is = selectedTab.indexOf(val) !== -1;
    return is || val === selectedTab;
  }, [selectedTab]);

  const handleDrawerOpen = useCallback((event) => {
    setIsUserDrawer(true);
  }, []);
  const handleDrawerClose = useCallback(() => {
    setIsUserDrawer(false);
  }, []);
  // 首页or刷新
  const reloadAndGoHome = useCallback(() => {
    if (selectedTab === Navigation.home.value) {
      window.location.reload();
    } else {
      history.push("/");
    }
  }, [history, selectedTab]);
  // 退出登录
  const onLogout = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    handleDrawerClose();
    logout();
    reloadAndGoHome();
  }, [handleDrawerClose, reloadAndGoHome]);
  
  const menuItemsView = useMemo(() => {
    return _.map(menu, element => {
      const isActive = isSelected(element.value);
      if (element.popup) {
        const triggerView = element?.icon ? (
          <IconButton 
            className={clsx("text-primary", classes.iconBtn, {
              [classes.textSecondary]: isActive,
              [classes.textBlack]: !isActive
            })}
            disableRipple
            disableTouchRipple
          >
            {element.icon}
          </IconButton>
        ) : (
          <Button
            size="large"
            classes={{ 
              text: clsx(classes.menuButtonText, {
                [classes.textSecondary]: isActive
              })
            }}
            disableRipple
            disableTouchRipple
          >
            {element.name}
          </Button>
        );
        const offsetX = element?.icon ? -32 : 0;
        return (
          <MPopup
            key={element.name}
            element={element}
            selectedTab={selectedTab}
            offsetY={8}
            offsetX={offsetX}
            trigger={triggerView}
          />
        );
      }
      if (element.link) {
        const iView = element?.icon && element.value !== LoginNavigation.login.value ? (
          <Tooltip
            title={element.name}
            aria-label={element.name}
            TransitionComponent={Fade} 
            TransitionProps={{ timeout: 200 }}
          >
            <IconButton
              onClick={element.onClick}
              className={clsx(classes.iconBtn, {
                [classes.textSecondary]: isActive,
                [classes.textBlack]: !isActive
              })}
            >
              <Badge badgeContent={msgCount || 0} color="error">
                {element.icon}
              </Badge>
            </IconButton>
          </Tooltip>
        ) : (
          <Button
            size="large"
            classes={{ 
              text: clsx(classes.menuButtonText, {
                [classes.textSecondary]: isActive
              })
            }}
            disableRipple
            disableTouchRipple
          >
            {element.name}
          </Button>
        );
        return (
          <Link
            key={element.name}
            to={element.link}
            className={classes.noDecoration}
            onClick={handleMobileDrawerClose}
          >
            {iView}
          </Link>
        );
      }
      return null;
    });
  }, [classes, handleMobileDrawerClose, isSelected, menu, msgCount, selectedTab]);

  const iconMenuView = useMemo(() => {
    if (_.isArray(iconMenu) && iconMenu.length) {
      return _.map(iconMenu, (im) => {
        const isActive = isSelected(im.value);
        if (im.link) {
          const iView = im.value === UserNavigation.notifies.value ? (
            <Badge badgeContent={msgCount || 0} color="error">
              {im.icon}
            </Badge>
          ) : im.icon;
          return (
            <Link
              key={im.value}
              to={im.link}
              className={classes.noDecoration}
            >
              <IconButton 
                aria-label={im.value}
                disableFocusRipple
                disableRipple
                disableTouchRipple
                className={clsx({
                  [classes.textSecondary]: isActive,
                  [classes.textBlack]: !isActive
                })}
              >
                {iView}
              </IconButton>
            </Link>
          );
        }
        return (
          <IconButton
            disableFocusRipple
            disableRipple
            disableTouchRipple
            key={im.value}
            onClick={handleDrawerOpen}
            aria-label={im.value}
            className={clsx({
              [classes.textSecondary]: isActive,
              [classes.textBlack]: !isActive
            })}
          >
            {im.icon}
          </IconButton>
        );
      });
    }
    return null;
  }, [iconMenu, isSelected, handleDrawerOpen, classes, msgCount]);

  useEffect(() => {
    if (userInfo?.token) {
      run({ token: userInfo.token });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?.token]);

  useEffect(() => {
    let isLoginMenu = userLogoutMenuItems;

    if (userInfo?.token && result) {
      // 添加点击方法
      const { list } = UserNavigation.back;
      const newList = _.map(list, (l) => {
        if (l.click && l.value === "back-logout") {
          l.onClick = onLogout;
        }
        return l;
      });
      setLoginMenu(newList);

      // 消息中心、用户中心
      UserNavigation.back.list = newList;
      isLoginMenu = _.values(UserNavigation);
    }
    setMenu([ ...menuItems, ...isLoginMenu ]);
    setIconMenu(isLoginMenu);
  }, [onLogout, result, userInfo?.token]);

  return (
    <div className={classes.root}>
      <AppBar 
        position="fixed" 
        className={clsx(classes.appBar, {
          [classes.shadow]: _.includes(hasNotShadow, selectedTab) && !isWidthUp("md", width)
        })}
      >
        <Toolbar className={classes.toolbar}>
          <Box display="flex" alignItems="center">
            <img
              alt=""
              src={ImgNav.logo}
              className={classes.img}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                history.push("/");
              }}
            />
          </Box>
          <div>
            <Hidden mdUp>
              {iconMenuView}
              <IconButton
                onClick={handleMobileDrawerOpen}
                aria-label="Open Navigation"
              >
                <Menu className={classes.textBlack} />
              </IconButton>
            </Hidden>
            <Hidden smDown>
              {menuItemsView}
            </Hidden>
          </div>
        </Toolbar>
      </AppBar>
      <NavigationDrawer
        menuItems={loginMenu}
        anchor="top"
        selectedItem={selectedTab}
        open={isUserDrawer}
        onClose={handleDrawerClose}
      />
      <NavigationDrawer
        menuItems={menuItems}
        anchor="top"
        selectedItem={selectedTab}
        open={mobileDrawerOpen}
        onClose={handleMobileDrawerClose}
      />
    </div>
  );
}
NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleMobileDrawerOpen: PropTypes.func,
  handleMobileDrawerClose: PropTypes.func,
  mobileDrawerOpen: PropTypes.bool,
};

export default withWidth()(withStyles(styles, { withTheme: true })(NavBar));